import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { CommandMessageResponse } from '../models/command-message-response';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
// tslint:disable-next-line:import-spacing
import {CommandMessageRequest} from  '../models/command-message-request';
import {Command} from '../models/command';

@Injectable({
    providedIn: 'root'
})
export class CommandDataService {
    constructor(private http: HttpClient) { }

    createRequest = (request: CommandMessageRequest): Observable<CommandMessageResponse[]> => {
        return this.http.post<CommandMessageResponse[]>(`${environment.api.baseUrl}/${environment.api.endpoints.diagtool.commandRequest}`, {...request});
    }

    getResponsesByCommand = (uuids: string[]): Observable<CommandMessageResponse[]> => {
        return this.http.get<CommandMessageResponse[]>(`${environment.api.baseUrl}/${environment.api.endpoints.diagtool.commandResponseByUuid}?uuids=${uuids.reduce((acc, uuid) => acc ? acc + ',' + uuid : acc + uuid, '')}`, );
    }

    getCommandlist = (projectId: number): Observable<Command[]> => {
        return this.http.get<Command[]>(`${environment.api.baseUrl}/${environment.api.endpoints.diagtool.commandList}?projectId=${projectId}`);
    }
    getBoxIdsByProject = (projectId: number): Observable<number[]> => {
        return this.http.get<number[]>(`${environment.api.baseUrl}/${environment.api.endpoints.diagtool.boxList}?projectId=${projectId}`);
    }

    getCommandsHistory = (request: CommandMessageRequest): Observable<CommandMessageResponse[]> => {
        const params = new HttpParams()
            .set('projectId', request.projectId.toString())
            .set('trainIds', request.trainIds.reduce((acc, trainId) => acc ? acc + ',' + trainId.toString() : trainId.toString(), ''))
            .set('boxIds', request.boxIds.reduce((acc, boxId) => acc ? acc + ',' + boxId.toString() : boxId.toString(), ''))
            .set('commands', request.commands.reduce((acc, command) => acc ? acc + ',' + command : command, '' ));

        return this.http.get<CommandMessageResponse[]>(`${environment.api.baseUrl}/${environment.api.endpoints.diagtool.commandResponse}`, {params});
    }

}
